import { z } from 'zod';

import type { PatchAdminV1OrgStoresIdBody, Store } from '@nucleus-commerce/api-client/admin';

export const emailSenderSchema = z.object({
  fromName: z.string().trim().max(120, { error: 'stores:validation.senderNameLength' }),
  replyTo: z
    .string()
    .trim()
    .refine((v) => v === '' || z.email().safeParse(v).success, {
      error: 'stores:validation.email',
    }),
});

export type EmailSenderValues = z.infer<typeof emailSenderSchema>;

export function fromEmailSettings(store: Pick<Store, 'settings'>): EmailSenderValues {
  const { fromName, replyTo } = store.settings.email;
  return { fromName: fromName ?? '', replyTo: replyTo ?? '' };
}

/** Blank means "use the default": the store name as sender, the support email for replies. */
export function toEmailSettingsPatch(values: EmailSenderValues): PatchAdminV1OrgStoresIdBody {
  return {
    settings: {
      email: {
        fromName: values.fromName === '' ? null : values.fromName,
        replyTo: values.replyTo === '' ? null : values.replyTo,
      },
    },
  };
}
